export const IPMPV0ABI = [
  {
    inputs: [
      {
        internalType: 'address',
        name: 'coreContract',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'tokenId',
        type: 'uint256'
      },
      {
        components: [
          {
            internalType: 'string',
            name: 'key',
            type: 'string'
          },
          {
            internalType: 'enum IPMPV0.ParamType',
            name: 'configuredParamType',
            type: 'uint8'
          },
          {
            internalType: 'bytes32',
            name: 'configuredValue',
            type: 'bytes32'
          },
          {
            internalType: 'bool',
            name: 'configuringArtistString',
            type: 'bool'
          },
          {
            internalType: 'string',
            name: 'configuredValueString',
            type: 'string'
          }
        ],
        internalType: 'struct IPMPV0.PMPInput[]',
        name: 'pmpInputs',
        type: 'tuple[]'
      }
    ],
    name: 'configureTokenParams',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
] as const
